import React from 'react';
import { Star } from 'lucide-react';
interface StarRatingProps {
  rating?: number;
  reviewCount?: number;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}
export function StarRating({
  rating = 4.8,
  reviewCount = 1000,
  size = 'md',
  className = ''
}: StarRatingProps) {
  const sizeClasses = {
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-base'
  };
  const starSize = {
    sm: 14,
    md: 16,
    lg: 18
  };
  return <div className={`flex items-center gap-2 ${sizeClasses[size]} ${className}`} data-id="element-129">
      <div className="flex items-center gap-0.5" data-id="element-130">
        {[1, 2, 3, 4, 5].map(star => <Star key={star} size={starSize[size]} className={star <= Math.floor(rating) ? 'fill-yellow-400 text-yellow-400' : 'text-gray-300'} data-id="element-131" />)}
      </div>
      <span className="font-semibold text-gray-900" data-id="element-132">{rating}</span>
      <span className="text-gray-500" data-id="element-133">
        ({reviewCount?.toLocaleString()}+ reviews)
      </span>
    </div>;
}